import React from 'react'
import styled from 'styled-components'
import { height, width, border, color, variant, BorderProps } from 'styled-system'
import gradientAvatar from 'gradient-avatar'

import theme from '../../theme'

export interface AvatarProps {
  email?: string
  name: string
  size?: keyof typeof SIZE_PROPS
  url?: string
  variant?: keyof typeof theme.avatarStyles
}

interface ImageProps extends BorderProps {
  variant?: AvatarProps['variant']
}

export const avatarStyle = variant({ key: 'avatarStyles', prop: 'variant' })

export const SIZE_PROPS = {
  small: {
    fontSize: 10,
    height: 22,
    width: 22
  },
  medium: {
    fontSize: 20,
    height: 34,
    width: 34
  },
  large: {
    fontSize: 30,
    height: 75,
    width: 75
  }
}

const Image = styled.img.attrs(props => ({
  variant: 'default',
  borderRadius: '50%',
  borderStyle: 'solid',
  borderWidth: '2px',
  ...props
}))<ImageProps>`
  background: white;
  display: inline-block;
  object-fit: cover;
  vertical-align: middle;
  transition: border-color 150ms linear;
  ${avatarStyle}
  ${border}
  ${color}
  ${height}
  ${width}
`

const Avatar = ({
  email,
  name = '',
  size = 'medium',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  variant = 'default',
  url,
  ...props
}: AvatarProps): JSX.Element => {
  const sizeProps = SIZE_PROPS[size]

  if (url) {
    return <Image alt={name} src={url} variant={variant} {...sizeProps} {...props} />
  } else {
    const uid = name || email || new Date()

    return (
      <Image
        alt={name}
        src={`data:image/svg+xml;base64,${btoa(gradientAvatar(uid.toString()))}`}
        variant={variant}
        {...sizeProps}
        {...props}
      />
    )
  }
}

export default Avatar
